<template>
  <div id="n_-0_TOP__">
    <div class="seal">
      <div class="title">{{ this.campaign.name }}</div>
      <div
        class="slider"
        v-bind:class="{ sliderTopPos: !getExpiredAfter(this.campaign.end_at) }"
      >
        <Plate3
          :base="this.campaign.template_url"
          :seals="this.campaign.seals"
          :sealsList="this.campaign.seals"
          v-if="this.campaign.goal_count === 3"
        />
        <Plate6
          :base="this.campaign.template_url"
          :seals="this.campaign.seals"
          :sealsList="this.campaign.seals"
          v-if="this.campaign.goal_count === 6"
        />
        <Plate9
          :base="this.campaign.template_url"
          :seals="this.campaign.seals"
          :sealsList="this.campaign.seals"
          v-if="this.campaign.goal_count === 9"
        />
        <div class="paging" v-if="this.campaign.seals.length >= this.campaign.goal_count">
          <div v-bind:class="{'cell1': this.page === 1, 'cell1active': this.page !== 1}" @click="tapBack()"> BACK</div>
           <div class="cell2">
              {{this.page}}</a> / {{getMaxPage()}}</a>
          </div>
          <div @click="tapNext()" v-bind:class="{'cell3': getMaxPage() === this.page, 'cell3active': getMaxPage() !== this.page}">NEXT </div>
        </div>
       <div class="ichiran" @click="goIchiran()"><img src="@/assets/img/seal/ichiran_btn.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'
import moment from 'moment'
import Plate3 from '@/components/SealPlate3.vue'
import Plate6 from '@/components/SealPlate6.vue'
import Plate9 from '@/components/SealPlate9.vue'
import { FactoryTrack, ContentsType } from '../constant/firebase'

export default {
  name: 'PreviousSeal.',
  components: {
    Plate3,
    Plate6,
    Plate9
  },
  props: ['name', 'end_at', 'template_url', 'seals', 'goal_count', 'detail'],
  data: function () {
    return {
      page: 1,
      isAndroid: false,
      isShowNewPlate: true,
      campaign: null
    }
  },
  async created() {
    document.title = '香の川製麺お店めぐり'
    const accTime = new DateFormatter().format(new Date())
    // 同一ページでリロード対策に、詳細データはLocalStorageにも保存する
    console.log(this.data)
    if (!this.data) {
      this.campaign = JSON.parse(window.localStorage.getItem('seal-detail'))
    } else {
      this.campaign = this.data
      window.localStorage.setItem('seal-detail', JSON.stringify(this.data))
      console.log(this.campaign)
    }
  },
  mounted: function () {
    const ua = window.navigator.userAgent
    if (ua.indexOf('Android') >= 0) {
      this.isAndroid = true
    }
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 50)
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      data: 'SealList/detailSeal'
    })
  },
  watch: {},
  methods: {
    ...mapActions('Native', ['actionNavigateTo']),
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('SealPrefectures', ['action_SelectDetailSeal']),
    ...mapActions('Analytics', ['trackEvent']),
    moment,
    getExpiredAfter(str) {
      const array = str.split('.')
      const dateAt = new Date(array[0])
      const today = new Date()
      if (dateAt.getTime() > today.getTime()) {
        return true
      } else {
        return false
      }
    },
    tapPlateClose() {
      this.isShowNewPlate = false
    },
    goIchiran() {
      window.localStorage.setItem('seal-showItem', '過去のキャンペーン')
      this.$router.push({
        name: 'Seal',
        params: { showItem: '過去のキャンペーン' }
      })
    },
    tapBack() {
      if (this.page >= 2) {
        this.page = this.page - 1
        location.href = '#slide-' + this.page
      }
      if (this.page >= 1) {
        this.isBackPage = false
      } else {
        this.isBackPage = true
      }
      return false
    },
    getMaxPage() {
      return (
        ((this.campaign.seals.length / this.campaign.goal_count) | 0) +
        1
      )
    },
    tapNext() {
      if (
        this.page <
        ((this.campaign.seals.length / this.campaign.goal_count) | 0) +
          1
      ) {
        this.page = this.page + 1
        location.href = '#slide-' + this.page
        return false
      }
    },
    getSealsCount: async function () {
      return this.campaign.seals.length
    }
  }
}
</script>

<style lang="scss" scoped>
#n_-0_TOP__ {
  position: relative;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  font-family: Hiragino Kaku Gothic ProN;
}
.hed {
  position: relative;
}

.hed img {
  width: 100%;
  height: auto;
  display: block;
}
.tt_center {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Hiragino Kaku Gothic ProN;
  font-style: normal;
  font-weight: normal;
  font-size: 3.5vw;
  text-align: center;
  color: rgba(90, 34, 0, 1);
}
.seal {
  position: absolute;
  justify-content: center;
  display: flex;
  width: 100vw;
  padding-bottom:20vw;
  background: #ffffff;
}
.title {
  width: 94vw;
  height: 13vw;
  background-color: #592205;
  border-radius: 5px 5px 5px 5px;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  position: absolute;
  font-size: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6vw;
}

.title_gray {
  width: 94vw;
  height: 13vw;
  background-color: #bbbbbb;
  border-radius: 5px 5px 5px 5px;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  position: absolute;
  font-size: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4vw;
}

.paging {
  position: relative;
  background-color: #f6f6f6;
  width: 100%;
  height: 11vw;
  display: block;
  padding-top: 3vw;
  margin-bottom: 1vw;
}

.cell1active {
  position: absolute;
  font-size: 3.3vw;
  color: #5a2200;
  width: 20%;
  left: 0px;
}
.cell1active::before {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/left_icon.png');
}

.cell1 {
  position: absolute;
  font-size: 3.3vw;
  color: #bbbbbb;
  width: 20%;
  left: 0vw;
}
.cell1::before {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/left_icon_off.png');
}

.cell2 {
  position: absolute;
  font-size: 3.3vw;
  left: 20vw;
  width: 60%;
}
.cell3active {
  position: absolute;
  font-size: 3.3vw;
  color: #5a2200;
  left: 78.5vw;
  width: 20%;
}
.cell3active::after {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/right_icon.png');
}
.cell3 {
  position: absolute;
  font-size: 3.3vw;
  color: #bbbbbb;
  left: 78.5vw;
  width: 20%;
}

.cell3::after {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/right_icon_off.png');
}

.new_get {
  position: relative;
  width: 100%;
  height: 12vw;
}
.new_get img {
  width: 100%;
  height: auto;
  display: block;
}
.new_get p {
  position: absolute;
  display: block;
  width: 6vw;
  height: 6vw;
  top: 3vw;
  right: 3vw;
}

.history {
  background: #ffffff;
}

.item {
  width: 100%;
  height: 18vw;
  display: flex;
  border-bottom: 1px solid #707070;
}

.item_title {
  width: 100%;
  color: #592205;
  font-weight: bold;
  position: absolute;
  font-size: 3.8vw;
  display: block;
  justify-content: left;
  align-items: left;
  margin-top: 4vw;
  margin-left: 3vw;
  text-align: left;
  clear: both;
}
.item_hiduke {
  color: #999999;
  font-weight: normal;
  position: absolute;
  font-size: 2.5vw;
  display: block;
  justify-content: left;
  align-items: left;
  margin-top: 10vw;
  margin-left: 3vw;
  text-align: left;
}

.item > div:after {
  content: '';
  display: inline-block;
  position: absolute;
  right: 15px;
  width: 1.8vw;
  height: 3.2vw;
  margin-top: 7vw;
  margin-right: 1vw;
  align-items: right;
  background-image: url('~@/assets/img/seal/next_mark.png');
  background-size: contain;
}

.prefectures_text {
  color: #222222;
  font-weight: normal;
  position: relative;
  font-size: 3vw;
  display: block;
  margin: 0 auto;
  padding-top: 4vw;
  width: 75vw;
  text-align: center;
}

.prefecturesType {
  background: #ffffff;
}

.prefectures {
  position: relative;
  height: 13vw;
  background-color: #592205;
  margin-top: 4vw;
  width: 92vw;
  margin: 0 auto;
  display: flex;
  margin-top: 4vw;
  justify-content: space-between;
}

.prefectures .pp {
  color: #ffffff;
  font-weight: bold;
  font-size: 4vw;
  left: 4vw;
  display: inline-block;
  margin-left: 4vw;
  margin-top: 3vw;
}

.prefectures .cc {
  color: #ffffff;
  font-weight: bold;
  font-size: 4vw;
  display: inline-block;
  margin-right: 4vw;
  margin-top: 3vw;
}
.sealBox {
  position: relative;
  width: 94vw;
  display: flex;
  flex-wrap: wrap;
  margin-left: 4vw;
  margin-bottom: 5vw;
}
.sealBox .sealItem {
  position: relative;
  width: 30vw;
  height: 27vw;
  padding: 0vw;
  margin-right: 1vw;
  margin-top: 5vw;
  margin-bottom: 5vw;
}
.sealBox .sealItem img {
  width: 100%;
  height: auto;
  display: block;
}

.sealBox .sealItem .t1 {
  position: absolute;
  font-size: 2.9vw;
  font-weight: bold;
  width: 100%;
  top: 0.5vw;
  margin: 0;
}

.sealBox .sealItem .t1.is_android {
  top: 1.5vw;
  font-size: 3.1vw;
}

.sealBox .sealItem .stroke {
  position: absolute;
  color: red;
  font-size: 2.9vw;
  font-weight: bold;
  text-align: center;
  width: 100%;
  top: 0.5vw;
  margin: 0;
  -webkit-text-stroke: 3px white;
  text-stroke: 3px white;
}
.sealBox .sealItem .stroke.is_android {
  top: 1.5vw;
  font-size: 3.1vw;
}

.sealBox .sealItem .t2 {
  position: absolute;
  color: white;
  font-size: 2.1vw;
  text-align: center;
  width: 100%;
  top: 26.8vw;
}

.sealBox .sealItem .t2.is_android {
  top: 27.1vw;
}
.coupon_text {
  clear: both;
  display: block;
  width: 64vw;
  height: 4vw;
  margin: auto;
  margin-top: 5vw;
}
.coupon_text img {
  width: 100%;
  height: auto;
}

.rule_title {
  width: 90vw;
  position: relative;
  display: flex;
  justify-content: left;
  align-items: left;
  margin-top: 5vw;
  clear: both;
}

.rule_title img {
  width: 100%;
  height: auto;
}

.prefecture_item {
  width: 94vw;
  position: relative;
  background: #ff0000;
}

.rule_desc {
  width: 90vw;
  color: #592205;
  font-weight: normal;
  position: relative;
  font-size: 3.5vw;
  display: block;
  margin-top: 2vw;
  line-height: 1.7;
  justify-content: left;
  align-items: left;
  text-align: left;
  clear: both;
}
.seal_faq {
  display: block;
  width: 71vw;
  height: 4vw;
  margin: auto;
  margin-top: 5vw;
  left: 15vw;
  padding-bottom: 10vw;
}

.seal_faq img {
  width: 100%;
  height: auto;
  display: block;
}
.slider {
  width: 94vw;
  height: auto;
  text-align: center;
  overflow: hidden;
}

.sliderTopPos {
  margin-top: 4vw;
  display: inline-block;
}
.nextActive {
  color: #5a2200;
}

.no_campaigns {
  width: 94vw;
  border-radius: 5px 5px 5px 5px;
  color: #e03535;
  font-weight: bold;
  text-align: center;
  position: absolute;
  font-size: 4vw;
  display: block;
  justify-content: center;
  align-items: center;
  margin-top: 21vw;
}
.ichiran {
  width: 94vw;
  background-color: #ffffff;
  position: absolute;
  justify-content: center;
  align-items: center;
  margin-top: 4vw;
  margin-left: 0vw;
  padding-bottom: 30vw;
  clear: both;
}

.ichiran img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
